export const restaurants = [
  {
    id: "1",
    name: "Bella Vista Restaurant",
    description: "Authentic Italian cuisine with a modern twist",
    address: "123 Main Street, Downtown",
    phone: "+1 (555) 123-4567",
    image:
      "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
    logo: "https://images.unsplash.com/photo-1555396273-367ea4eb4db5?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80",
    categories: ["appetizers", "pasta", "pizza", "desserts", "beverages"],
    menu: {
      appetizers: [
        {
          id: "app1",
          name: "Bruschetta al Pomodoro",
          description: "Grilled bread with fresh tomatoes, basil, and garlic",
          price: 12.99,
          image:
            "https://images.unsplash.com/photo-1572441713132-51c75654db73?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          category: "appetizers",
          available: true,
        },
        {
          id: "app2",
          name: "Antipasto Platter",
          description: "Selection of cured meats, cheeses, and olives",
          price: 18.99,
          image:
            "https://images.unsplash.com/photo-1544025162-d76694265947?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          category: "appetizers",
          available: true,
        },
      ],
      pasta: [
        {
          id: "pasta1",
          name: "Spaghetti Carbonara",
          description: "Classic Roman pasta with eggs, cheese, and pancetta",
          price: 16.99,
          image:
            "https://images.unsplash.com/photo-1621996346565-e3dbc353d2e5?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          category: "pasta",
          available: true,
        },
        {
          id: "pasta2",
          name: "Fettuccine Alfredo",
          description: "Creamy fettuccine with parmesan cheese sauce",
          price: 15.99,
          image:
            "https://images.unsplash.com/photo-1551183053-bf91a1d81141?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          category: "pasta",
          available: true,
        },
        {
          id: "pasta3",
          name: "Penne Arrabbiata",
          description: "Spicy penne with tomato sauce and red peppers",
          price: 14.99,
          image:
            "https://images.unsplash.com/photo-1551892374-ecf8754cf8b0?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          category: "pasta",
          available: true,
        },
      ],
      pizza: [
        {
          id: "pizza1",
          name: "Margherita",
          description: "Classic pizza with tomato, mozzarella, and basil",
          price: 14.99,
          image:
            "https://images.unsplash.com/photo-1604382354936-07c5d9983bd3?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          category: "pizza",
          available: true,
        },
        {
          id: "pizza2",
          name: "Pepperoni",
          description: "Traditional pepperoni pizza with mozzarella",
          price: 16.99,
          image:
            "https://images.unsplash.com/photo-1628840042765-356cda07504e?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          category: "pizza",
          available: true,
        },
        {
          id: "pizza3",
          name: "Quattro Stagioni",
          description:
            "Four seasons pizza with artichokes, mushrooms, ham, and olives",
          price: 19.99,
          image:
            "https://images.unsplash.com/photo-1574071318508-1cdbab80d002?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          category: "pizza",
          available: true,
        },
      ],
      desserts: [
        {
          id: "dessert1",
          name: "Tiramisu",
          description: "Classic Italian dessert with coffee and mascarpone",
          price: 8.99,
          image:
            "https://images.unsplash.com/photo-1571877227200-a0d98ea607e9?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          category: "desserts",
          available: true,
        },
        {
          id: "dessert2",
          name: "Panna Cotta",
          description: "Vanilla panna cotta with berry compote",
          price: 7.99,
          image:
            "https://images.unsplash.com/photo-1551024506-0bccd828d307?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          category: "desserts",
          available: true,
        },
      ],
      beverages: [
        {
          id: "bev1",
          name: "Italian Soda",
          description: "Sparkling water with flavored syrup",
          price: 4.99,
          image:
            "https://images.unsplash.com/photo-1544145945-f90425340c7e?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          category: "beverages",
          available: true,
        },
        {
          id: "bev2",
          name: "Espresso",
          description: "Traditional Italian coffee",
          price: 3.99,
          image:
            "https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          category: "beverages",
          available: true,
        },
        {
          id: "bev3",
          name: "House Wine",
          description: "Red or white wine selection",
          price: 8.99,
          image:
            "https://images.unsplash.com/photo-1506377247375-2a5b3b417ebb?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          category: "beverages",
          available: true,
        },
      ],
    },
  },
  {
    id: "2",
    name: "Sakura Sushi Bar",
    description: "Fresh sushi and Japanese cuisine",
    address: "456 Cherry Blossom Ave",
    phone: "+1 (555) 987-6543",
    image:
      "https://images.unsplash.com/photo-1579584425555-c3ce17fd1871?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
    logo: "https://images.unsplash.com/photo-1579952363873-27d3bfad9c0d?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80",
    categories: ["appetizers", "sushi", "ramen", "desserts", "beverages"],
    menu: {
      appetizers: [
        {
          id: "app3",
          name: "Edamame",
          description: "Steamed soybeans with sea salt",
          price: 6.99,
          image:
            "https://images.unsplash.com/photo-1559847844-5315695dadae?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          category: "appetizers",
          available: true,
        },
        {
          id: "app4",
          name: "Gyoza",
          description: "Pan-fried pork dumplings",
          price: 9.99,
          image:
            "https://images.unsplash.com/photo-1496116218417-1a781b1c416c?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          category: "appetizers",
          available: true,
        },
      ],
      sushi: [
        {
          id: "sushi1",
          name: "California Roll",
          description: "Crab, avocado, and cucumber roll",
          price: 12.99,
          image:
            "https://images.unsplash.com/photo-1579584425555-c3ce17fd1871?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          category: "sushi",
          available: true,
        },
        {
          id: "sushi2",
          name: "Salmon Nigiri",
          description: "Fresh salmon over sushi rice",
          price: 8.99,
          image:
            "https://images.unsplash.com/photo-1579584425555-c3ce17fd1871?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          category: "sushi",
          available: true,
        },
        {
          id: "sushi3",
          name: "Dragon Roll",
          description: "Eel, cucumber, and avocado with eel sauce",
          price: 16.99,
          image:
            "https://images.unsplash.com/photo-1579584425555-c3ce17fd1871?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          category: "sushi",
          available: true,
        },
      ],
      ramen: [
        {
          id: "ramen1",
          name: "Tonkotsu Ramen",
          description: "Rich pork bone broth with chashu and egg",
          price: 14.99,
          image:
            "https://images.unsplash.com/photo-1569718212165-3a8278d5f624?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          category: "ramen",
          available: true,
        },
        {
          id: "ramen2",
          name: "Miso Ramen",
          description: "Miso-based broth with vegetables and tofu",
          price: 13.99,
          image:
            "https://images.unsplash.com/photo-1569718212165-3a8278d5f624?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          category: "ramen",
          available: true,
        },
      ],
      desserts: [
        {
          id: "dessert3",
          name: "Mochi Ice Cream",
          description: "Green tea, vanilla, and strawberry mochi",
          price: 6.99,
          image:
            "https://images.unsplash.com/photo-1551024506-0bccd828d307?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          category: "desserts",
          available: true,
        },
      ],
      beverages: [
        {
          id: "bev4",
          name: "Green Tea",
          description: "Traditional Japanese green tea",
          price: 3.99,
          image:
            "https://images.unsplash.com/photo-1544145945-f90425340c7e?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          category: "beverages",
          available: true,
        },
        {
          id: "bev5",
          name: "Sake",
          description: "Premium Japanese rice wine",
          price: 12.99,
          image:
            "https://images.unsplash.com/photo-1506377247375-2a5b3b417ebb?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          category: "beverages",
          available: true,
        },
      ],
    },
  },
];

export const getRestaurantById = (id) => {
  return restaurants.find((restaurant) => restaurant.id === id);
};

export const getAllMenuItems = (restaurantId) => {
  const restaurant = getRestaurantById(restaurantId);
  if (!restaurant) return [];

  return Object.values(restaurant.menu).flat();
};
